import { Component, OnInit  } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import { BaseComponent } from '../../share/component/base.component';
declare var $;
declare var Swiper;
@Component({
  selector: 'home-component',
  templateUrl: './home.component.html'
})
export class HomeComponent extends BaseComponent implements OnInit  {

  public IsAd = true;
  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
    var _ad = this.jslib.GetStorage('ad');
    if(typeof _ad == 'object'){
      var record = (new Date(_ad['sec'])).getDay();
      var now = (new Date()).getDay();
      this.IsAd =  (now != record);
    }
  }

  public Industries;
  public rootUrl = this.config.rootUrl;
  ngOnInit() {
    this.GetAd();
    this.infoShow();
    this.baseApi.apiGet('v1/asset/industries',{all:false}).then((i_res)=>{
      if(i_res){
        this.Industries = i_res;
      }else{
        this.Industries = [];
      }
      this.ngzone.runOutsideAngular(()=>{
        this.SetBanner();
      });
    });
    
    this.GetHot();
  }


  SetBanner(){
    if(this.IsMobile){
      //banner
      setTimeout(()=>{

        var swiper = new Swiper('.swiper-container', {
          effect: 'coverflow',
          slidesPerView: 1,
          spaceBetween: 0,
          autoHeight:true,
          loop: true,
          slidesOffsetBefore:1,
          slidesOffsetAfter:1,
          coverflowEffect: {
            modifier: 1,
            slideShadows: false,
          },
          navigation: {
            nextEl: '#next',
            prevEl: '#before',
            },
        });
        this.BannerListen();

      },0);

    }else{
      //banner
      setTimeout(()=>{

        var myPlugin = {
          name: 'debugger',
          params: {
            debugger: true,
          },
          on: {
            slideChange: function (swiper) {
              if (!swiper.params.debugger) return;
              
              var total = 6;
              var _index = this.activeIndex;
              //回推四個
              var display = [];
              for(var i = 0;i < 4;i++){
                display.push(((_index - i) + (total-3)));
              }
              var s = $('.item.swiper-slide');
              for(var i = 0; i < s.length;i++){
                if(display.includes(i)){
                    $('.item.swiper-slide').eq(i).removeClass('unview');
                }else{
                    $('.item.swiper-slide').eq(i).addClass('unview');
                }
              }

            }
          },
        };
        Swiper.use(myPlugin);
        var swiper = new Swiper('.swiper-container', {
          // effect: 'coverflow',
          slidesPerView: 4,
          spaceBetween: 30,
          autoHeight:true,
          loop: true,
          slidesOffsetBefore:1,
          slidesOffsetAfter:1,
          navigation: {
            nextEl: '#next',
            prevEl: '#before',
            },
        });
        this.BannerListen();

      },0);
    }
  }

  public HotData;
  public eventType  = this.config.eventType;
  public enrollStatus = this.config.enrollStatus;
  
  GetHot(){
    this.baseApi.apiGet('v1/event/hotEvents',{}).then((res)=>{
      this.HotData = res;
      this.HotData.forEach(item => {
        var _status = this.enrollStatus[item['enrollStatus']];
        item['statusClass'] = _status['class'];
        item['statusName'] = _status['name'];
        var _evt = this.eventType[item['eventType']];
        item['typeName'] = _evt['name'];
      });
      //console.log('HotData',res);
    });
  }

  //無窮loop會讀不到綁定事件
  BannerListen(){
    this.ngzone.runOutsideAngular(()=>{
      window['bnrEvt'] = null;
      window['bnrEvt'] = $('.item.swiper-slide').on('click',(event)=>{
        var _id = $(event.currentTarget).attr('data-id');
        this.BannerSearch(_id);
      });
    });
  };
  BannerSearch(index){
    var item = this.Industries[index];
    var Query = {
      main:1,//產業
      select:item['id'],
      name:item['name']
    }
    this.jslib.SetStorage('search',Query);
    this.ngzone.run(()=>{
      this.route.navigateByUrl('/search');
    });
  }
  
  closeAd(){
    $(".banner").animate({height:"0"});
    var record = (new Date()).getTime();
    var _ad = {sec:record}
    this.jslib.SetStorage('ad',_ad);
  }
  //是否顯示說明banner
  public Isinfo = false;
  infoShow(){
    var temp = this.jslib.GetStorage('isviewed');
    if(temp){
      this.Isinfo = false;
    }else{
      this.jslib.SetStorage('isviewed',true);
      this.Isinfo = true;
    }
  }

  public MainAD;
  public SideAD;
  public NewsData;
  GetAd(){
    this.baseApi.apiGet('v1/home/banners',{}).then((ad_res:any)=>{
      this.MainAD = ad_res.find(item =>{return item['location'] == 0});
      this.SideAD= ad_res.filter(item =>{return item['location'] > 0});
    });
    this.baseApi.apiGet('v1/home/messages',{}).then((n_res:any)=>{
      this.NewsData = n_res;
      //console.log('NewsData',this.NewsData);
      //新聞跑馬燈
      setTimeout(()=>{
        this.ngzone.runOutsideAngular(()=>{
          $("#marquee").marquee();
        })
      },150);
    });
  }
  OpenUrl(item){
    if(item['url']){
      window.open(item['url']);
    }
  }
}
